import { type QuoteAppsPanelState } from './constants';
import {
  type ReqsReviewAppMeta,
  type QuoteFilesAppMeta,
  type ChatAppMeta,
  type AppPanelMetaMap,
} from './types';

// Union type for meta that can be passed to actions
export type AppPanelMeta = ReqsReviewAppMeta | QuoteFilesAppMeta | ChatAppMeta;

export const types = {
  SET_QUOTE_APPS_PANEL_STATE:
    'quotes/quoteItems/apps/SET_QUOTE_APPS_PANEL_STATE',
  UPDATE_APP_META: 'quotes/quoteItems/apps/UPDATE_APP_META',
} as const;

interface SetAppsPanelStateAction {
  type: typeof types.SET_QUOTE_APPS_PANEL_STATE;
  payload: {
    appsPanelState: QuoteAppsPanelState | null;
    meta?: AppPanelMeta;
  };
}

interface UpdateAppMetaAction<T extends QuoteAppsPanelState> {
  type: typeof types.UPDATE_APP_META;
  payload: {
    appType: T;
    meta: AppPanelMetaMap[T];
  };
}

export type QuoteAppsAction =
  | SetAppsPanelStateAction
  | UpdateAppMetaAction<QuoteAppsPanelState>;

export const quoteAppsPanel = {
  setAppsPanelState: ({
    appsPanelState,
    meta,
  }: {
    appsPanelState: QuoteAppsPanelState | null;
    meta?: AppPanelMeta;
  }): SetAppsPanelStateAction => ({
    type: types.SET_QUOTE_APPS_PANEL_STATE,
    payload: { appsPanelState, meta },
  }),

  updateAppMeta: <T extends QuoteAppsPanelState>(
    appType: T,
    meta: AppPanelMetaMap[T],
  ): UpdateAppMetaAction<T> => ({
    type: types.UPDATE_APP_META,
    payload: { appType, meta },
  }),
  // Backward compatibility - use generic updateAppMeta instead
  updateReqsReviewMeta: (meta: ReqsReviewAppMeta) =>
    quoteAppsPanel.updateAppMeta('REQS_REVIEW' as const, meta),
};
